module.exports = __webpack_public_path__ + "img/Bingo_Info_Game10.4431715c.png";